const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpok16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 0a1.0001 1.0001 0 0 0-0.70703 0.29297l-7 7a1.0001 1.0001 0 0 0 0.70703 1.707h3v6a1.0001 1.0001 0 0 0 1 1h4.8828l-1.7773-3.5527c-0.33239-0.66495 0.15113-1.4472 0.89453-1.4473h2c0.34896 0.01446 0.66509 0.20992 0.83398 0.51562l0.16602-0.38867v-2.127h0.91211l0.16797-0.39453c0.1579-0.36769 0.51976-0.60586 0.91992-0.60547h1.9941a1.0001 1.0001 0 0 0-0.28711-0.70703l-7-7a1.0001 1.0001 0 0 0-0.70703-0.29297z",
    color: "#000000",
    fill: "#afc6e9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302 9-2.0762 4.8457-0.92383-1.8457h-2l2 4h2l3-7z",
    color: "#000000",
    fill: "#008000",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpok16);
export default __webpack_public_path__ + "static/media/up.ok.16.5730dd676cf40e8041fe2444fb245831.svg";
export { ForwardRef as ReactComponent };